import React from 'react';
import { CheckIcon, MapPinIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { projectFeatures, site } from '../data/site';
const PROJECT_IMAGE = 'https://cdn.magicpatterns.com/uploads/vAGfsAYkwCCz3jG1WnFThG/img7.jpg';
export function ProjectSection() {
  return <section id="proyecto" className="bg-white py-20 lg:py-28" data-id="element-253" data-mp="1s47etwoq7svj">
      <div className="mx-auto grid max-w-7xl items-center gap-12 px-5 lg:grid-cols-[1.05fr_1fr] lg:gap-20 lg:px-8" data-id="element-254" data-mp="1s3pdiln7iogr">
        <Reveal className="relative" data-id="element-255" data-mp="1n2i4kj9bvj8i">
          <img src={PROJECT_IMAGE} alt="Vista aérea de los lotes delimitados y las calles internas de Hacienda El Rodeo" className="aspect-[3/2] w-full rounded-sm object-cover shadow-card" data-id="element-256" data-mp="1i5i5wtet5irf" />
          <div className="absolute -bottom-6 left-6 flex items-center gap-2 bg-forest-900 px-5 py-4 text-white sm:left-8" data-id="element-257" data-mp="196wfkc33gzg3">
            <MapPinIcon size={18} className="text-gold-400" data-id="element-258" data-mp="37id8x7lei2dr" />
            <span className="text-[12px] uppercase tracking-[0.12em]" data-id="element-259" data-mp="33jmc71kukmr6">{site.ubicacion}</span>
          </div>
        </Reveal>

        <Reveal delay={0.06} data-id="element-260" data-mp="3on13g0gkdj3a">
          <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-gold" data-id="element-261" data-mp="3tkkjn5wto5xv">
            El proyecto
          </p>
          <h2 className="mt-3 font-display text-3xl leading-tight text-forest-900 md:text-[42px]" data-id="element-262" data-mp="3flbcswuiao6k">
            Hacienda El Rodeo
          </h2>
          <p className="mt-6 text-[15px] leading-relaxed text-forest-900/75" data-id="element-263" data-mp="3jnokhqstcw5z">
            48 hectáreas de tierra fértil rodeadas de montaña, a 15 minutos del casco urbano de
            Santa Catarina Mita y sobre la ruta que conecta Jutiapa con el oriente del país. Cada
            lote se entrega delimitado, con servicios instalados y escritura pública individual: la
            tranquilidad de vivir en el campo con la certeza jurídica de una inversión formal.
          </p>
          <p className="mt-4 text-[15px] leading-relaxed text-forest-900/75" data-id="element-264" data-mp="u3mml4ujq122">
            El crecimiento comercial de la zona ha elevado el valor del metro cuadrado año con año.
            Comprar hoy en El Rodeo es asegurar un patrimonio que aumenta mientras usted decide si
            construir su casa, su finca de descanso o simplemente esperar.
          </p>

          <ul className="mt-8 space-y-3.5" data-id="element-265" data-mp="zpvi7w457532">
            {projectFeatures.map(feature => <li key={feature} className="flex gap-3 text-[14px] leading-snug text-forest-900/85" data-id="element-266" data-mp="usn0fwmwp32c">
                <CheckIcon size={18} className="mt-0.5 shrink-0 text-gold" strokeWidth={2.5} data-id="element-267" data-mp="ptsgush47ah6" />
                {feature}
              </li>)}
          </ul>

          <a href="#contacto" className="mt-9 inline-flex rounded-full bg-forest-900 px-8 py-4 text-[12px] font-semibold uppercase tracking-[0.14em] text-white transition-[background-color,transform] duration-150 ease-smooth hover:bg-forest-700 active:scale-[0.98]" data-id="element-268" data-mp="h072ha8v3v8a">
            Agendar una visita
          </a>
        </Reveal>
      </div>
    </section>;
}